import React, { useState, useEffect } from 'react';
import {
    TableHead,
    TableBody,
    TablePagination,
    TextField,
    Grid,
    Container, Typography, Paper
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { GetCookieInfo } from '../../../logic/CookieManager';
import {
    StyledButtonOrange,
    StyledButtonContainer,
    StyledTableCell,
    StyledTableHeadRow,
    StyledTable, StyledTableBodyRow, StyledTableCellHeader, StyledButtonBlack
} from "../../../styles/MyStyles";
import {GetEnumMenuItems, GetEnumValueName} from "../../../logic/EnumHelper";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';

const UsersPage = () => {
    const [clients, setClients] = useState([]);
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const [selectedRole, setSelectedRole] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        const fetchUsers = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(process.env.REACT_APP_USERS_URL, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    const users = data.data;
                    setUsers(users);
                } else {
                    console.log('Fetch users failed.');
                }
            } catch (error) {
                // Handle network errors or other exceptions
                console.log('An error occurred:', error);
            }
        };
        fetchUsers();
    }, []);

    const blockUnblockUser = async (e, userId, isBlocked) => {
        e.stopPropagation();
        try {
            const tokenCookie = GetCookieInfo('nplt');
            const response = await fetch(`${process.env.REACT_APP_USERS_URL}/block`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + tokenCookie.value,
                },
                body: JSON.stringify({
                    userId: userId,
                    isBlocked: isBlocked
                }),
            });
            if (response.ok) {
                const data = await response.json();


                if (data.success) {
                    let newArr = [];

                    users.forEach((elem) => {
                        if (elem.id === userId) {
                            elem.isBlocked = isBlocked;
                        }
                        newArr.push(elem);
                    });

                    setUsers(newArr);
                }
            } else {
                console.log('Block/unblock user failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }

    };

    const handleRoleFilter = (event) => {
        setSelectedRole(event.target.value);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchQueryChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const createUser = () => {
        navigate(`new`);
    };

    // Filter the clients based on the search query
    const filteredUsers = users ? users.filter(
        (user) =>
            user.email.toLowerCase().includes(searchQuery.toLowerCase()) &&
            (selectedRole === '' || user.role === parseInt(selectedRole))
    ) : [];

    // Calculate pagination values
    const totalUsers = filteredUsers.length;
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    const paginatedUsers = filteredUsers.slice(startIndex, endIndex);

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        label="Search"
                        value={searchQuery}
                        onChange={handleSearchQueryChange}
                        margin="normal"
                        size="small"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Role"
                        value={selectedRole}
                        onChange={handleRoleFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {GetEnumMenuItems('userRole', true)}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={createUser} margin="normal">
                            New
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={5}>Id</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Email</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Role</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Contact</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={5}>Is Blocked</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {paginatedUsers.map((user) => (
                                <StyledTableBodyRow key={user.id}>
                                    <StyledTableCell>{user.id}</StyledTableCell>
                                    <StyledTableCell>{user.email}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('userRole', user.role)}</StyledTableCell>
                                    <StyledTableCell>{user.contactId === Number(process.env.REACT_APP_NEWCENT_CONTACT_ID) ? 'Newcent' : GetClientViewName(clients.find(e => e.id === user.contactId))}</StyledTableCell>
                                    <StyledTableCell  style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div>
                                            {user.isBlocked ? 'Yes' : 'No'}
                                        </div>
                                        {user.isBlocked ? (
                                            <StyledButtonOrange style={{ marginLeft: '10px' }} variant="contained" component="span"
                                                               onClick={(e) => blockUnblockUser(e, user.id,false)}>
                                                <LockOpenIcon fontSize={'small'}/>
                                            </StyledButtonOrange>
                                        ) : (
                                            <StyledButtonBlack style={{ marginLeft: '10px' }} variant="contained" component="span"
                                                               onClick={(e) => blockUnblockUser(e, user.id, true)}>
                                                <LockIcon fontSize={'small'}/>
                                            </StyledButtonBlack>
                                        )}
                                    </StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
                <Grid item xs={12} sx={{ textAlign: 'left' }}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 20, 50]}
                        component="div"
                        count={totalUsers}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Grid>
            </Grid>
        </Container>
    );
};

export default UsersPage;
